import type { ReactNode } from "react";
import { t } from "../i18n/en";
export interface AppMenuItem {
  id: string;
  label: ReactNode;
  active?: boolean;
  onSelect: () => void;
}
export function AppMenu({
  account,
  close,
  id,
  items,
  onSignOut,
}: {
  account?: { email: string; username?: string; displayName?: string };
  close: () => void;
  id: string;
  items: AppMenuItem[];
  onSignOut?: () => void;
}) {
  return (
    <>
      <button
        type="button"
        aria-label={t("ui.copy_close_menu_18e91489")}
        tabIndex={-1}
        onClick={close}
        className="harness-menu-backdrop fixed inset-0 z-30 cursor-default"
      />
      <nav id={id} aria-label={t("ui.copy_account_menu_672cf2b1")} className="harness-app-menu">
        {account ? (
          <div className="harness-app-menu-account">
            <span className="harness-app-menu-account-label">
              {t("ui.copy_signed_in_as_56dc13d6")}
            </span>
            {account.username || account.displayName ? (
              <strong>{account.username ? `@${account.username}` : account.displayName}</strong>
            ) : null}
            <span title={account.email}>{account.email}</span>
          </div>
        ) : null}
        {items.length > 0 ? (
          <div className="harness-app-menu-items">
            {items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`harness-app-menu-item ${item.active ? "is-active" : ""}`}
                onClick={() => {
                  close();
                  item.onSelect();
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        ) : null}
        {onSignOut ? (
          <button
            type="button"
            className="harness-app-menu-item is-danger"
            onClick={() => {
              close();
              onSignOut();
            }}
          >
            {t("common.signOut")}
          </button>
        ) : null}
      </nav>
    </>
  );
}
